
  jQuery(document).ready(function(){
    jQuery('.product-slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: false,
      arrows: true, // Enable arrows
      prevArrow: '<button type="button" class="slick-prev-custom"> <img src="https://cdn.shopify.com/s/files/1/0698/4866/2262/files/left-chevron.png?v=1716291676"> </button>',
      nextArrow: '<button type="button" class="slick-next-custom"> <img src="https://cdn.shopify.com/s/files/1/0698/4866/2262/files/chevron.png?v=1716291676"> </button>'
    });
  });


function openVariantTabCst(variantName) {
  var i, tabcontent, tablabels;
  tabcontent = document.getElementsByClassName("tab-content-cst");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablabels = document.getElementsByClassName("tab-label-cst");
  for (i = 0; i < tablabels.length; i++) {
    tablabels[i].className = tablabels[i].className.replace(" active-cst", "");
  }
  document.getElementById(variantName).style.display = "block";
  event.currentTarget.className += " active-cst";
}

// Open the first tab by default
document.addEventListener("DOMContentLoaded", function() {
  var firstTabLabel = document.querySelector(".tab-label-cst");
  if (firstTabLabel) {
    firstTabLabel.click();
  }
});;
document.addEventListener("DOMContentLoaded", function() {
 const slider = document.querySelector('.headline_slider');
    const content = slider.querySelectorAll('.content');
    const spanText = content[0].querySelector('span').textContent;

    function repeatSpan() {
        const spanWidth = content[0].querySelector('span').offsetWidth;
        const sliderWidth = slider.offsetWidth;
        const repeatCount = Math.ceil(sliderWidth / spanWidth) + 1;

        content.forEach(container => {
            container.innerHTML = '';
            for (let i = 0; i < repeatCount; i++) {
                const newSpan = document.createElement('span');
                newSpan.textContent = spanText;
                container.appendChild(newSpan);
            }
        });

        const totalWidth = spanWidth * repeatCount;
        content[0].style.width = `${totalWidth}px`;
        content[1].style.width = `${totalWidth}px`;
        slider.style.animationDuration = `${totalWidth / 5}s`;
    }

    window.addEventListener('resize', repeatSpan);

    repeatSpan();
});;